import type { ClubMemberRole } from '../../api';
import { canHaveOwnershipShare } from '../../utils/isGeneralUser';
import ModalOverlay from '../modal/ModalOverlay';
import ModalPortal from '../modal/ModalPortal';

type RoleOption = { value: ClubMemberRole; label: string };

type Props = {
  name: string;
  restoreRole: ClubMemberRole;
  createRoleOptions: RoleOption[];
  onRoleChange: (role: ClubMemberRole) => void;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function RestoreMemberModal({
  name,
  restoreRole,
  createRoleOptions,
  onRoleChange,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <ModalPortal>
      <ModalOverlay onClose={onCancel}>
        <div
          className="modal members-restore-modal"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-labelledby="members-restore-modal-title"
        >
          <h3 id="members-restore-modal-title">Восстановить: {name}</h3>
          <p className="members-shares-modal-hint">
            Выберите роль. Для пилота и админа нужно будет назначить доли
            владения; техник и гость восстанавливаются сразу.
          </p>
          <label className="members-field">
            <span>Роль</span>
            <select
              value={restoreRole}
              onChange={(e) => onRoleChange(e.target.value as ClubMemberRole)}
            >
              {createRoleOptions.map((r) => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </select>
          </label>
          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onCancel}>
              Отмена
            </button>
            <button type="button" className="btn-save" onClick={onConfirm}>
              {canHaveOwnershipShare(restoreRole)
                ? 'Далее — доли'
                : 'Восстановить'}
            </button>
          </div>
        </div>
      </ModalOverlay>
    </ModalPortal>
  );
}
